import { Modal } from 'bootstrap';
import { RevenueCatWrapper } from '../../utils/RevenueCatWrapper';

/** The map context menu's "Measure from here": `detail` is the clicked { lng, lat }. */
export const MEASURE_FROM_HERE_EVENT = 'measure-tool:measure-from-here';

/**
 * The measure tool is a PRO+ feature, as Quick Measurement was: anyone else is sent to
 * the purchase page. Resolves true when the caller may open it.
 */
export async function mayOpenMeasureTool(
  isPro: () => Promise<boolean> = () => RevenueCatWrapper.isProOrProPlus(),
  redirect: (path: string) => void = (path) => { window.location.href = path; },
): Promise<boolean> {
  if (await isPro()) return true;
  redirect('/purchases');
  return false;
}

/** Closes the map Options dialog the tool was opened from, if it is showing. */
export function hideMapOptionsDialog(doc: Document = document): void {
  const dialog = doc.getElementById('map-options-dialog');
  if (dialog) Modal.getOrCreateInstance(dialog).hide();
}

export function requestMeasureFromHere(lngLat: { lng: number; lat: number }, target: Window = window): void {
  target.dispatchEvent(new CustomEvent(MEASURE_FROM_HERE_EVENT, { detail: { lng: lngLat.lng, lat: lngLat.lat } }));
}
